import { useState } from 'react';
import { Label, Modal, ModalBody, ModalFooter, ModalHeader } from 'reactstrap';
import { Button, FormControl } from 'react-bootstrap';
import Select from 'react-select';
import ReactDatePicker from 'react-datepicker';
import ReactInputMask from 'react-input-mask';
import { format } from 'date-fns';
import ptBR from 'date-fns/locale/pt-BR';
import { toast } from 'react-toastify';
import { Filter, X } from 'react-feather';

const OPCOES_PERIODO = [
  { value: 'dia_atual', label: 'Dia Atual' },
  { value: 'semana_atual', label: 'Semana Atual' },
  { value: 'mes_atual', label: 'Mês Atual' },
  { value: 'ultimos_30_dias', label: 'Últimos 30 Dias' },
  { value: 'trimestre_atual', label: 'Trimestre Atual' },
  { value: 'ano_atual', label: 'Ano Atual' },
  { value: 'personalizado', label: 'Personalizado' },
];

const FiltrarPeriodo = ({ onFiltrar, onLimpar }) => {
  const [modalAberto, setModalAberto] = useState(false);
  const [dataAbertura, setDataAbertura] = useState(null);
  const [dataAberturaInicio, setDataAberturaInicio] = useState(null);
  const [dataAberturaFim, setDataAberturaFim] = useState(null);
  const [filtroAplicado, setFiltroAplicado] = useState(null);
  const [selectKey, setSelectKey] = useState(0);

  const isPersonalizado = dataAbertura?.value === 'personalizado';

  const handleBuscar = () => {
    if (!dataAbertura) {
      toast.warning('Selecione um período.');
      return;
    }
    if (isPersonalizado && (!dataAberturaInicio || !dataAberturaFim)) {
      toast.warning('Informe a data de início e a data de fim para o período personalizado.');
      return;
    }

    const filtro = {
      data_abertura: dataAbertura.value,
      data_abertura_inicio: dataAberturaInicio ? format(dataAberturaInicio, 'yyyy-MM-dd') : null,
      data_abertura_fim: dataAberturaFim ? format(dataAberturaFim, 'yyyy-MM-dd') : null,
      _label:
        dataAbertura.value === 'personalizado'
          ? `${format(dataAberturaInicio, 'dd/MM/yyyy')} - ${format(dataAberturaFim, 'dd/MM/yyyy')}`
          : dataAbertura.label,
    };
    setFiltroAplicado(filtro);
    onFiltrar(filtro);
    setModalAberto(false);
  };

  const handleLimpar = () => {
    setFiltroAplicado(null);
    setDataAbertura(null);
    setDataAberturaInicio(null);
    setDataAberturaFim(null);
    setSelectKey((k) => k + 1);
    onLimpar();
  };

  const handleFecharModal = () => {
    setModalAberto(false);
    setDataAbertura(null);
    setDataAberturaInicio(null);
    setDataAberturaFim(null);
    setSelectKey((k) => k + 1);
  };

  return (
    <>
      <div className='d-flex align-items-center justify-content-between mb-3' style={{ flexWrap: 'wrap', gap: '8px' }}>
        <div>
          {filtroAplicado && (
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
              <p style={{ fontSize: 15, fontWeight: 400, margin: 0 }}>Data Abertura: </p>
              <span className='badge bg-success d-flex align-items-center' style={{ fontSize: '12px', gap: '6px' }}>
                {filtroAplicado._label}
                <X
                  size={13}
                  onClick={handleLimpar}
                  style={{ cursor: 'pointer', marginLeft: '2px' }}
                  title='Remover filtro'
                />
              </span>
            </div>
          )}
        </div>
        <Button
          className='btn-primary d-flex align-items-center'
          style={{ gap: '6px' }}
          onClick={() => setModalAberto(true)}
        >
          <Filter size={15} className='m-r-2' /> Filtrar Período
        </Button>
      </div>

      <Modal isOpen={modalAberto} toggle={handleFecharModal} centered>
        <ModalHeader toggle={handleFecharModal}>Filtrar Período</ModalHeader>
        <ModalBody>
          <div key={selectKey}>
            <div className='mb-3'>
              <Label>Período</Label>
              <Select
                options={OPCOES_PERIODO}
                placeholder='Selecione'
                value={dataAbertura}
                onChange={(opt) => {
                  setDataAbertura(opt);
                  setDataAberturaInicio(null);
                  setDataAberturaFim(null);
                }}
              />
            </div>

            {isPersonalizado && (
              <div className='row'>
                <div className='col-6'>
                  <Label>Data Início</Label>
                  <FormControl
                    as={ReactDatePicker}
                    autoComplete='off'
                    selected={dataAberturaInicio}
                    onChange={(date) => setDataAberturaInicio(date)}
                    customInput={
                      <ReactInputMask mask='99/99/9999'>
                        {(inputProps) => <input {...inputProps} className='form-control datetimepicker-input digits' />}
                      </ReactInputMask>
                    }
                    locale={ptBR}
                    dateFormat='dd/MM/yyyy'
                    className='form-control datetimepicker-input digits'
                  />
                </div>
                <div className='col-6'>
                  <Label>Data Fim</Label>
                  <FormControl
                    as={ReactDatePicker}
                    autoComplete='off'
                    selected={dataAberturaFim}
                    onChange={(date) => setDataAberturaFim(date)}
                    customInput={
                      <ReactInputMask mask='99/99/9999'>
                        {(inputProps) => <input {...inputProps} className='form-control datetimepicker-input digits' />}
                      </ReactInputMask>
                    }
                    locale={ptBR}
                    dateFormat='dd/MM/yyyy'
                    className='form-control datetimepicker-input digits'
                  />
                </div>
              </div>
            )}
          </div>
        </ModalBody>
        <ModalFooter>
          <Button className='btn-primary' onClick={handleBuscar}>
            Buscar
          </Button>
          <Button className='btn-light' onClick={handleFecharModal}>
            Cancelar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default FiltrarPeriodo;
